import { parseRequestError } from '@/app/common/utilities'
import axios from 'axios'
import { GetAcademicTermsParams } from './types'
import {
  AcademicTermProgramArraySchema,
  ScholarshipAwardsResponseSchema,
  type ScholarshipAwardsResponse,
} from './schema'
import { GetScholarshipAwardsParams } from './types'

export const fetchScholarshipAwards = async (
  params: GetScholarshipAwardsParams
): Promise<ScholarshipAwardsResponse> => {
  try {
    const { programId, academicTermId, page = 1, pageSize = 10 } = params

    const response = await axios.get(
      `/programs/${programId}/academic_terms/${academicTermId}/student_scholarships`,
      {
        params: {
          page,
          per_page: pageSize,
          ...(params.search && { search: params.search }),
        },
      }
    )
    return ScholarshipAwardsResponseSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}

export const getAcademicTerms = async (params: GetAcademicTermsParams) => {
  try {
    const { programId } = params
    const response = await axios.get(`/programs/${programId}/academic_terms`)
    return AcademicTermProgramArraySchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}
